(() => {
  // One page controller. Editor replacement tears down the previous DOM bindings
  // before measuring the current header/footer and observing unrevealed tiles.
  let dispose = () => {};
  function init() {
    dispose();
    const cleanup = [];
    dispose = () => { cleanup.splice(0).forEach(fn => fn()); };
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const tiles = document.querySelectorAll('.hh-photo-features__tile:not(.hh-feature-seen)');
    if (typeof IntersectionObserver === 'function') {
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('hh-feature-seen');
          observer.unobserve(entry.target);
        }
      }, { threshold: .12 });
      tiles.forEach(tile => observer.observe(tile));
      cleanup.push(() => observer.disconnect());
    } else tiles.forEach(tile => tile.classList.add('hh-feature-seen'));
    const header = document.querySelector('#header-component');
    if (header && typeof MutationObserver === 'function') {
      const observer = new MutationObserver(() => {
        if (header.dataset.menuStyle === 'menu') {
          const drawer = header.querySelector('header-drawer');
          if (drawer?.isOpen) drawer.close();
        }
      });
      observer.observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
      cleanup.push(() => observer.disconnect());
    }
    const footer = document.querySelector('#halo-footer');
    const wrapper = document.querySelector('.page-wrapper');
    if (footer && wrapper) {
      const fit = () => wrapper.classList.toggle('hh-footer-reveal', innerWidth >= 768 && !media.matches && footer.offsetHeight < innerHeight - 40);
      if (typeof ResizeObserver === 'function') {
        const observer = new ResizeObserver(fit);
        observer.observe(footer);
        cleanup.push(() => observer.disconnect());
      }
      window.addEventListener('resize', fit, { passive: true });
      media.addEventListener('change', fit);
      cleanup.push(() => {
        window.removeEventListener('resize', fit);
        media.removeEventListener('change', fit);
        wrapper.classList.remove('hh-footer-reveal');
      });
      fit();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    dispose();
    // Deleting an unrelated section may not emit another load event. Rebind the
    // remaining page after Shopify has removed the unloaded element.
    window.requestAnimationFrame?.(init);
  });
})();
